import React, { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import ar from "./ar.json";
import en from "./en.json";

const DICT = { ar, en };
export const SUPPORTED = ["ar", "en"];
export const DEFAULT_LANG = "ar";

const I18nCtx = createContext({ lang: DEFAULT_LANG, t: (k) => k, dict: DICT.ar });

function resolve(obj, path) {
  const parts = path.split(".");
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

export function I18nProvider({ children }) {
  const { lang: routeLang } = useParams();
  const lang = SUPPORTED.includes(routeLang) ? routeLang : DEFAULT_LANG;
  const dict = DICT[lang];

  const value = useMemo(() => {
    const t = (key) => {
      const v = resolve(dict, key);
      return v === undefined ? key : v;
    };
    return { lang, t, dict };
  }, [lang, dict]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  return useContext(I18nCtx);
}
